export default __webpack_public_path__ + "60c811704b948eb291d360db849e95a4.ogg";